import { Assets, BitmapText, Container, Graphics, Sprite } from "pixi.js";
import { IScene, Manager } from "../core/Manager";
import { Reels } from "../reels/Reels";
// import { setSpinResponseDataGlobal } from "../config/GlobalVariableConfig";
import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { isSuperQuickBtnOnGlobal, RespinIndex, setMaxWinBtnClosedGlobal, waitUntilMaxWinBtnClosed, willBannerAutoProceedGlobal } from "../config/GlobalVariableConfig";
import { spinData } from "../server/getServerResposesFun";
// import { Banner } from "./Banner";
import { BigWin } from "./BigWin";
import { GameScene } from "./GameScene";

// import { sound } from "@pixi/sound";
import { sound } from "@pixi/sound";
import { Group } from "tweedle.js";
import { Logo } from "../components/Logo";
import { LogoComponent } from "../components/LogoComponent";
import { GAME_LAYOUT_HEIGHT, GAME_LAYOUT_WIDTH, REEL_SCALE, VISIBLE_SYMBOLS_PER_REEL } from "../config/reelConfig";
import { DisplayComponent } from "../core/displays/DisplayComponent";
import { DisplayComponentFactory } from "../core/displays/DisplayComponentFactory";
import { DisplayObject } from "../core/displays/DisplayObject";
import { reelSpinEmitter } from "../reels/ReelInit";
import { Reels as HoldAndSpinReels } from "../reelsHoldSpin/Reels";
import { getVisibleLocalBounds } from "../utils";

const tweenGroup: Group = new Group();

declare const window: any;

// let hitArea;

export class FreeGameScene extends Container implements IScene {

    // Asset bundles
    assetBundles: string[] = ["game-screen", "sound", "intro-screen", "big-win"];
    // private sceneScale: number = 0;

    // Containers
    private game = new Container();
    private reelFrame = new Container();


    private backgroundImageCont = new Container();

    // private characterCont = new Container();
    // private character: Spine | null = null;

    // private characterHitMask: Graphics = new Graphics();

    private backgroundSpine: Spine | null = null;

    private reels: Reels | null = null;
    protected holdAndSpinReels: HoldAndSpinReels | null = null;
    // private holdAndWinTrigger: Spine | null = null;
    // private banner: Banner | null = null;
    private bigWin: BigWin | null = null;

    // private backgroundMusic: Sound | null = null;

    private numberOfFS: number;
    private baseGameWin: number;
    private totalFGSessionWin: number; // this is total win including base spin

    private firstSpin: boolean = true;

    private numberOfFSPlayed: number = 0;

    private autoTriggerTimeout: ReturnType<typeof setTimeout>;

    private fgTransition: Spine | null = null;


    private multiplierVal: number = 0;
    private multiplierText: BitmapText | null = null;

    protected track: Sprite | null = null;
    // private multiplierMeter: Spine | null = null;

    // private boundAnimateCharacter: () => void;
    // private boundShakeEffect: () => void;

    // private boundCollectMouseMult: () => void;

    private pointerDownHandlerFree: () => void;

    constructor(numberOfFS: number, baseGameWin: number) {
        super();
        this.numberOfFS = numberOfFS;
        this.numberOfFSPlayed = 0;
        this.baseGameWin = baseGameWin;


        this.totalFGSessionWin = baseGameWin;

        this.firstSpin = true;


        // this.boundAnimateCharacter = this.animateCharacter.bind(this);
        // this.boundShakeEffect = this.shakeEffect.bind(this);
        // this.boundCollectMouseMult = this.collectMouseMult.bind(this);

        this.pointerDownHandlerFree = this.onBannerPointerDown.bind(this);

        // reelSpinEmitter.off('animateCharacter', this.boundAnimateCharacter);
        // reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        // reelSpinEmitter.off('collectMouseMult', this.boundCollectMouseMult);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        // reelSpinEmitter.on('animateCharacter', this.boundAnimateCharacter);
        // reelSpinEmitter.on('shakeEffect', this.boundShakeEffect);
        // reelSpinEmitter.on('collectMouseMult', this.boundCollectMouseMult);
        reelSpinEmitter.on('triggerFeature', this.handleFeature, this);
    }


    override  destroy() {

        // reelSpinEmitter.off('animateCharacter', this.boundAnimateCharacter);
        // reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        DisplayComponent.unregister(LogoComponent);

        // this.character.state.clearListeners();
        // this.character.removeAllListeners();
        // this.character.destroy(true);
        this.reels?.destroy();
        this.reels = null;
        Assets.unload(['freeBackgroundSkel', 'freeBackgroundAtlas']);
        super.destroy();

    }

    private async handleFeature(callback?: () => void): Promise<void> {
        if (callback) {
            await this.triggerHoldAndSpin(callback);
            return Promise.resolve();
        } else {
            return new Promise<void>(async (resolve) => {
                console.log("trigger holdAndSpin from handleFeature");
                await this.triggerHoldAndSpin(resolve);
            });
        }

    }

    // private appearHoldAndWinText(): Promise<void> {
    //     return new Promise<void>((resolve) => {
    //         if (!this.holdAndWinTrigger) {
    //             resolve();
    //             return;
    //         }

    //         this.holdAndWinTrigger.visible = true;
    //         this.holdAndWinTrigger.state.setAnimation(0, "animation", false).listener = {
    //             complete: () => {
    //                 this.holdAndWinTrigger.state.clearListeners();
    //                 this.holdAndWinTrigger.visible = false;
    //                 resolve();
    //             }
    //         };
    //     });

    // }

    private async triggerHoldAndSpin(callback: () => void): Promise<void> {
        // 1. Initialize, but keep hidden
        RespinIndex.increase();
        this.holdAndSpinReels = new HoldAndSpinReels();
        this.holdAndSpinReels.position.set(this.reels.x, this.reels.y);
        this.holdAndSpinReels.pivot.set(this.reels.pivot.x, this.reels.pivot.y);
        this.holdAndSpinReels.scale.set(this.reels.scale.x, this.reels.scale.y);
        this.holdAndSpinReels.visible = false; // Hide it initially!
        this.reelFrame.addChild(this.holdAndSpinReels);

        // 2. Play impact and text over the CURRENT base game reels
        // this.playHoldAndSpinImpactVfx();
        (DisplayComponent.get(LogoComponent).getInstance() as Logo).playWin();
        await this.reels.appearHoldAndWinText();

        // 3. Play the Spine wipe, and swap the reels under the cover of the animation
        await this.playHoldAndSpinTransition();

        // 4. Base game is now hidden, Bonus is visible. Start the spins!
        (DisplayComponent.get(LogoComponent).getInstance() as Logo).playIdle();
        await this.spinHoldAndSpinReel();

        // 5. Reset back to base game
        await this.playReelFrameResetTransition();

        // 6. Cleanup
        if (this.holdAndSpinReels) {
            this.reelFrame.removeChild(this.holdAndSpinReels);
            this.holdAndSpinReels.destroy();
            this.holdAndSpinReels = null;
        }
        callback();
    }

    // private playHoldAndSpinImpactVfx(): void {
    //     // this.playHoldAndSpinShockwave();
    //     // this.playHoldAndSpinParticles();
    //     // this.shakeEffect(); // Your existing screen shake

    //     // Add a heavy "Punch In" camera effect using Tweedle
    //     const originalScaleX = this.reelFrame.scale.x;
    //     const originalScaleY = this.reelFrame.scale.y;

    //     new Tween(this.reelFrame.scale, tweenGroup)
    //         .to({
    //             x: originalScaleX * 1.05, // 5% quick zoom in
    //             y: originalScaleY * 1.05
    //         }, 150) // Fast inward punch
    //         .easing(Easing.Quadratic.Out)
    //         .yoyo(true)
    //         .repeat(1) // Bounces back out
    //         .onComplete(() => {
    //             // Failsafe reset
    //             this.reelFrame.scale.set(originalScaleX, originalScaleY);
    //         })
    //         .start();
    // }

    private playHoldAndSpinTransition(): Promise<void> {
        return new Promise<void>((resolve) => {
            const transition = Spine.from({
                skeleton: "holdAndSpinTransitionSkel",
                atlas: "holdAndSpinTransitionAtlas"
            });

            transition.label = "holdAndSpinTransition";
            transition.position.set(GAME_LAYOUT_WIDTH / 2, GAME_LAYOUT_HEIGHT / 2);
            this.game.addChild(transition);

            // THE FIX: Swap the reels halfway through the transition.
            // Adjust this timeout (e.g., 400ms) to match the exact frame your Spine animation covers the screen.
            setTimeout(() => {
                if (this.reels && this.holdAndSpinReels) {
                    this.reels.visible = false;
                    this.holdAndSpinReels.visible = true;
                }
            }, 400);

            transition.state.setAnimation(0, "transition_blast", false).listener = {
                complete: () => {
                    transition.state.clearListeners();
                    this.game.removeChild(transition);
                    transition.destroy();
                    resolve();
                }
            };
        });
    }

    private playReelFrameResetTransition(): Promise<void> {
        return new Promise<void>((resolve) => {
            const transition = Spine.from({
                skeleton: "reelFrameResetTransitionSkel",
                atlas: "reelFrameResetTransitionAtlas"
            });

            transition.label = "reelFrameResetTransition";
            transition.position.set(GAME_LAYOUT_WIDTH / 2, GAME_LAYOUT_HEIGHT / 2);
            this.game.addChild(transition);


            setTimeout(() => {
                if (this.reels && this.holdAndSpinReels) {
                    this.reels.visible = true; // Show normal reels
                    this.holdAndSpinReels.visible = false; // Hide bonus reels
                }
            }, 400);
            const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
            sound.play('transition_sound', { volume: 1, speed: timeScale });
            transition.state.setAnimation(0, "stone_falling", false).listener = {
                complete: () => {
                    transition.state.clearListeners();
                    this.game.removeChild(transition);
                    transition.destroy();
                    resolve();
                }
            };
        });
    }

    private async spinHoldAndSpinReel() {

        let freeGameTrigger = 0;
        let winAmount = 0;
        let accumulatedsWinAmount = 0;
        // let totalFGSessionWin: number;

        if (this.reels) {
            // RespinIndex.increase();
            [freeGameTrigger, winAmount, accumulatedsWinAmount] = await this.holdAndSpinReels.startPlay("BASE");

            console.log("freeGameTrigger", freeGameTrigger);
            console.log("winAmount", winAmount);

        }

        //  return [freeGameTrigger, winAmount, accumulatedsWinAmount];

        console.log("Freegame while loop for", RespinIndex.value, freeGameTrigger, "winAmount", winAmount, "accumulatedsWinAmount", accumulatedsWinAmount);

        if (winAmount > 0) {

            const isMaxWin = (freeGameTrigger === -2) ? true : false;

            if (isMaxWin) {
                await this.bigWin.bigWinFunction(winAmount, isMaxWin);
            }
        }


        if (winAmount > 0) {
            await new Promise(resolve => setTimeout(resolve, 200));
        }

        //if (freeGameTrigger == -1 || freeGameTrigger == -2) {
        // totalFGSessionWin = accumulatedsWinAmount;
        // }

    }

    // private shakeEffect() {

    //     console.log("inside shakeEffect");

    //     let duration = 250;
    //     let intensity = 20;

    //     const original = { x: this.x, y: this.y };
    //     const offset = { x: 0, y: 0 };

    //     const tween = new Tween(offset, tweenGroup)
    //         .to({ x: 0, y: 0 }, duration)
    //         .onUpdate(() => {
    //             this.x = original.x + (Math.random() - 0.5) * intensity;
    //             this.y = original.y + (Math.random() - 0.5) * intensity;
    //         })
    //         .onComplete(() => {
    //             this.x = original.x;
    //             this.y = original.y;
    //             tweenGroup.remove(tween);
    //         })
    //         .start();
    // }


    public async constructorWithAssets(): Promise<void> {

        this.setupBackground();


        this.setupLogo();
        this.setupTransition();

        console.log("before Reels");
        this.reels = new Reels();
        // this.background.addChild(this.reels);
        // this.reels.position.set(-506, -395);
        // this.reels.alpha = 0;

        this.setupReelFrame();

        // this.setupTriggerText();
        this.bigWin = new BigWin(Manager.screenwidth, Manager.screenHeight);
        this.bigWin.position.set(Manager.screenwidth / 2, Manager.screenHeight / 2);
        this.addChild(this.bigWin);

        this.resize(Manager.screenwidth, Manager.screenHeight);


    }

    // private setupTriggerText() {
    //     this.holdAndWinTrigger = Spine.from({
    //         skeleton: "holdWinTextSkel",
    //         atlas: "holdWinTextAtlas"
    //     });
    //     this.holdAndWinTrigger.label = "holdAndWinTrigger";
    //     this.holdAndWinTrigger.position.set(1550, 1370);
    //     this.holdAndWinTrigger.visible = false;
    //     this.game.addChild(this.holdAndWinTrigger);
    // }

    private callExitFreeGameAuto() {

        this.autoTriggerTimeout = setTimeout(() => {
            clearTimeout(this.autoTriggerTimeout);
            console.log("calling freeGameSceneChnage exitFreeGame pointerdown auto")
            this.exitFreeGame();
        }, 10000); // 10 seconds
    }

    private onBannerPointerDown(): void {
        clearTimeout(this.autoTriggerTimeout);
        console.log("calling freeGameSceneChnage exitFreeGame pointerdown")

        this.exitFreeGame();

        Manager.banner.off('pointerdown', this.pointerDownHandlerFree);

    }


    // private animateCharacter(name: string): void {

    //     this.character?.state.setAnimation(0, `${name}`, false);
    // }


    public async freeSpinPlay() {


        // Manager.banner.bgContainer.once('pointerdown', () => {

        //     clearTimeout(this.autoTriggerTimeout);
        //     console.log("calling freeGameSceneChnage exitFreeGame pointerdown")

        //     this.exitFreeGame();
        // });


        // this.updateMultiplier(0);
        // this.updateSurgeMeter(0);

        this.updateTotalMult(0);

        // casinoChannel.publish('featureRoundStarted', { uistate: 'freespins', gameMode: 'fs_' });
        // Manager.casinoChannelHandler.reportFeatureRoundStarted();

        console.log("casinoChannel-featureRoundStarted")

        // this point to start the transition animation 
        this.fgTransition.state.setAnimation(0, "stone_falling", false);

        // casinoChannel.publish('updateFeatureCounter', { counterValue: 111 });
        // casinoChannel.publish('updateFeatureTotalWin', { totalWinAmount: `${(99)}` });

        // casinoChannel.publish('updateFeatureCounter', { counterValue: this.numberOfFS });
        // Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS)

        console.log("this.numberOfFS", this.numberOfFS);


        console.log("casinoChannel-updateFeatureCounter")

        // this.ui?.resetWinValue();

        const fsRevealIndexes = spinData.respins
            .map((respin, index) => (respin.type === "fs_reveal" ? index : -1))
            .filter(index => index !== -1);

        console.log("fsRevealIndexes", fsRevealIndexes);

        let freeGameTrigger = 1;
        let winAmount: number;
        let accumulatedsWinAmount: number;

        while (freeGameTrigger != -1 && freeGameTrigger != -2) {

            // this.ui.setFreeGameCounter(totalFreeGame, totalFreeGame - freeSpinRemaining + 1);
            //update counter here


            Manager.casinoChannelHandler.reportFeatureRoundStarted();


            if (this.firstSpin) // first time counter appear
            {
                this.firstSpin = false;
                Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);
                Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((this.baseGameWin * 100).toFixed(0));
                await new Promise(resolve => setTimeout(resolve, 500));

                // await at this point to get transition animation emitt a singnal to start ie, event named "change"
                if (this.transitionChangePromise) {
                    await this.transitionChangePromise;
                    console.log("'change' event awaited and received in freeSpinPlay");
                }

            }

            this.numberOfFS = this.numberOfFS - 1;
            if (this.numberOfFS >= 0) {
                Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);
                this.numberOfFSPlayed = this.numberOfFSPlayed + 1;
            }


            [freeGameTrigger, winAmount, accumulatedsWinAmount] = await this.spinReel();

            console.log("Freegame while loop for", RespinIndex.value, freeGameTrigger, "winAmount", winAmount, "accumulatedsWinAmount", accumulatedsWinAmount);

            if (winAmount > 0 && freeGameTrigger != -1) {
                await this.bigWin.bigWinFunction(winAmount);
            }

            // if (freeGameTrigger > 0) {

            //     console.log("RespinIndex.value", RespinIndex.value);
            //     await this.reels?.processWinFeatureSymbol(RespinIndex.value);

            //     this.numberOfFS = this.numberOfFS + freeGameTrigger;

            //     Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);


            // }

            Manager.casinoChannelHandler.reportFeatureRoundCompleted((winAmount * 100).toFixed(0));

            const featureWinCentsNum = Math.floor(winAmount * 100);
            console.log("reportUpdateFeatureTotalWin", featureWinCentsNum);

            Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((accumulatedsWinAmount * 100).toFixed(0));

            if (winAmount > 0) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }

            if (freeGameTrigger == -1 || freeGameTrigger == -2) {
                this.totalFGSessionWin = accumulatedsWinAmount;
            }

        }

        console.log("Freegame while loop exit");

        if (Manager.banner) {

            if (freeGameTrigger === -2) { // max win reached
                setMaxWinBtnClosedGlobal(false);
                Manager.casinoChannelHandler.reportMaxWin();

                // wait here till isMaxWinBtnClosedGlobal == true;

                await waitUntilMaxWinBtnClosed();

            }

            Manager.casinoChannelHandler.reportFeatureExit();
            await Manager.banner.appearFreeGameOutroBanner(this.totalFGSessionWin, this.numberOfFSPlayed);

            if (willBannerAutoProceedGlobal) {
                this.callExitFreeGameAuto();
            }

            console.log("appearFreeGameOutroBanner");

            const game = new GameScene();
            await Manager.changeScene(game, false);

            Manager.banner.on('pointerdown', this.pointerDownHandlerFree);

        }


    }

    private async exitFreeGame() {
        // Manager.casinoChannelHandler.reportFeatureExit();

        // currentBackgorundMusic.stop();

        console.log("casinoChannel-featureExit");

        // this.backgroundMusic?.stop();
        await Manager.banner?.disappearBanner();



        // reportGameRoundCompleted();
        Manager.casinoChannelHandler.reportGameRoundCompleted();

    }

    private async spinReel(): Promise<[number, number, number]> {

        let freeGameTrigger = 0;
        let winAmount = 0;
        let accumulatedsWinAmount = 0;

        if (this.reels) {

            [freeGameTrigger, winAmount, accumulatedsWinAmount] = await this.reels.startPlay("FREEGAME");

            console.log("freeGameTrigger", freeGameTrigger);
            console.log("winAmount", winAmount);

            // this.reels?.setReelRunning(false);
        }

        return [freeGameTrigger, winAmount, accumulatedsWinAmount];

    }


    private setupBackground(): void {

        // this.backgroundImageCont.addChild(Sprite.from('backgroundFree'));
        // this.addChild(this.backgroundImageCont);


        // this.background.addChild(Sprite.from('baseReels'));

        this.backgroundSpine = Spine.from({
            skeleton: "freeBackgroundSkel",
            atlas: "freeBackgroundAtlas",
        });

        // this.backgroundSpine.position.set(3000 / 2, 3000 / 2);
        this.addChild(this.backgroundSpine);
        this.track = Sprite.from("free_track");
        this.game.addChild(this.track);

        this.addChild(this.game);
    }

    private transitionChangePromise: Promise<void> | null = null;
    private resolveTransitionChange: (() => void) | null = null;

    private setupTransition(): void {
        this.fgTransition = Spine.from({
            skeleton: "reelFrameResetTransitionSkel",
            atlas: "reelFrameResetTransitionAtlas"
        });
        this.fgTransition.label = "fgTransition";

        // Create a Promise that resolves on 'change' event
        this.transitionChangePromise = new Promise<void>((resolve) => {
            this.resolveTransitionChange = resolve;
        });

        this.fgTransition.state.addListener({
            start: () => {
                console.log("fgTransition Started");
            },
            event: (_entry, event) => {
                if (event.data.name === "change") {
                    console.log("fgTransition emitted 'change' event");

                    if (this.resolveTransitionChange) {
                        this.resolveTransitionChange();
                        this.resolveTransitionChange = null; // prevent multiple calls
                    }

                }
            },
            complete: () => {

                this.fgTransition.destroy();
                this.fgTransition = null;
                console.log("fgTransition completed");
            }
        });
    }



    private setupLogo(): void {
        DisplayComponent.register(new DisplayComponentFactory(LogoComponent));
        DisplayComponent.get(LogoComponent).init();
        let inst = DisplayComponent.get(LogoComponent).getInstance();
        this.game.addChild(inst);
        this.setupMultiplierText();
    }

    private setupMultiplierText() {

        // this.multiplierMeter = Spine.from({
        //     skeleton: "multiplerMeterSkel",
        //     atlas: "multiplerMeterAtlas"
        // })
        // this.multiplierMeter.label = "multiplierMeter";

        // this.logoContainer.addChild(this.multiplierMeter)


        // this.multiplierMeter.state.addListener({
        //     complete: (entry: any) => {
        //         if (["start", "collect"].includes(entry.animation.name)) {
        //             this.multiplierMeter.state.setAnimation(0, "idle", true);
        //             this.multiplierMeter.state.clearListeners();
        //         }
        //     }
        // });


        // this.multiplierMeter.state.setAnimation(0, "idle", true);

        this.multiplierVal = 0;
        this.multiplierText = new BitmapText({
            text: "",
            style: {
                fontFamily: 'dtt_coin_font',
                fontSize: 100
            }
        });

        // this.multiplierText.scale = 1;
        this.multiplierText.anchor = 0.5;
        // this.multiplierText.position.set(0, 107);
        // this.logoContainer.addChild(this.multiplierText);

        // this.multiplierMeter.addSlotObject("text_dev", this.multiplierText);
        // console.log(this.sceneScale);

    }

    // private setupCharacter(): void {
    //     this.character = Spine.from({
    //         skeleton: "characterSkel",
    //         atlas: "characterAtlas"
    //     })
    //     this.character.label = "character";

    //     this.characterCont.addChild(this.character)
    //     // this.game.addChild(this.characterCont);


    //     // const leavesInFront = Spine.from({
    //     //     skeleton: "freeBgLeavesSkel",
    //     //     atlas: "freeBgLeavesAtlas"
    //     // });
    //     // leavesInFront.label = "leavesInFront";
    //     // leavesInFront.state.setAnimation(0, "leaves", true);
    //     // leavesInFront.position.set(65, 300);
    //     // this.characterCont.addChild(leavesInFront);


    //     const animations = this.character.skeleton.data.animations.map(anim => anim.name);
    //     console.log("Available char animations:", animations);

    //     this.character.scale = 0.5;

    //     this.character.state.data.setMix("idle_1", "idle_2", 0.25); // 0.25 seconds for mix
    //     this.character.state.data.setMix("idle_1", "win_1", 0.25); // 0.25 seconds for mix
    //     this.character.state.data.setMix("idle_2", "win_1", 0.25); // 0.25 seconds for mix
    //     this.character.state.data.setMix("idle_2", "win_2", 0.25); // 0.25 seconds for mix


    //     // this.character.state.data.setMix("idle_1", "action_0", 0.25); // 0.25 seconds for mix
    //     // this.character.state.data.setMix("idle_1", "action_1", 0.25); // 0.25 seconds for mix
    //     // this.character.state.data.setMix("idle_1", "action_2", 0.25); // 0.25 seconds for mix

    //     // this.character.state.data.setMix("idle_2", "action_0", 0.25); // 0.25 seconds for mix
    //     // this.character.state.data.setMix("idle_2", "action_1", 0.25); // 0.25 seconds for mix
    //     // this.character.state.data.setMix("idle_2", "action_2", 0.25); // 0.25 seconds for mix

    //     // this.character.state.data.setMix("idle_3", "action_0", 0.25); // 0.25 seconds for mix
    //     // this.character.state.data.setMix("idle_3", "action_1", 0.25); // 0.25 seconds for mix
    //     // this.character.state.data.setMix("idle_3", "action_2", 0.25); // 0.25 seconds for mix

    //     // // Add listener to return to "idle_1_port" after the win animation completes
    //     this.character.state.addListener({
    //         start: (entry: any) => {
    //             if (["win_1", "win_2"].includes(entry.animation.name)) {
    //                 // sound.play('wolf_character_animation4_redeyes', { volume: 1 });
    //                 if (entry.animation.name == "win_1") {
    //                     // sound.play('character_jumping_sound', { volume: 1 });
    //                 } else if (entry.animation.name == "win_2") {
    //                     // sound.play('character_guiter_playing_sound', { volume: 1 });
    //                 }
    //             }
    //             else if (["idle_2"].includes(entry.animation.name)) {
    //                 // sound.play('wolf_character_animation5_flicksknife', { volume: 1 });
    //                 // sound.play('character_licking_sound', { volume: 1 });
    //             }
    //         },
    //         complete: (entry: any) => {
    //             if (["idle_2", "win_1", "win_2"].includes(entry.animation.name)) {
    //                 this.character?.state.setAnimation(0, "idle_1", true);
    //             }

    //             // if (entry.animation.name == "win_1") {
    //             //     this.shakeEffect()
    //             // }

    //         }
    //     });


    //     this.character.eventMode = "static";
    //     this.character.on("pointerdown", this.onCharacterClick);

    //     //Adding hitmask for the character
    //     // this.characterHitMask.label = "spine Hitmask"
    //     // this.characterCont.addChild(this.characterHitMask);

    //     // this.characterHitMask.eventMode = "static";
    //     // this.characterHitMask.on("pointerdown", this.onCharacterClick);

    // }

    // private onCharacterClick = () => {


    //     // const winVariants = ["action_1_desk", "action_2_desk", "action_3_desk"];

    //     const winVariants = ["idle_2", "win_1", "win_2"];//

    //     const currentAnim = this.character?.state.getCurrent(0)?.animation?.name;

    //     if (currentAnim === "idle_1") {
    //         const randomIndex = Math.floor(Math.random() * winVariants.length);
    //         const winVariant = winVariants[randomIndex];
    //         this.character?.state.setAnimation(0, winVariant, false);
    //         console.log("winVariant ", winVariant);
    //     }
    // };


    private async setupReelFrame(): Promise<void> {


        const reelBack = Sprite.from('reelBackFree');
        console.log("reelBackSpine", reelBack);
        reelBack.position.set(-632, -500);
        reelBack.visible = false;
        //this.reelFrame.addChild(reelBack);

        // const multiplierBase = Sprite.from('reel_top_multiplier_base')
        // multiplierBase.position.set(326, -285);
        // multiplierBase.anchor = 0.5;
        // this.reelFrame.addChild(multiplierBase);

        //this.reels.position.set(-550, -400);
        this.reelFrame.addChild(this.reels);
        //this.calculateReeframePivot();
        // 1. Create the Graphics (Rectangle)
        const rect = new Graphics()
            .rect(0, 0, 1160, 1230)
            .fill(0xDE3249);

        rect.alpha = 0.01;
        this.reels.addChild(rect);

        // this.reelFrame.pivot.set(rect.width / 2, rect.height / 2);
        this.reels.pivot.set(rect.width / 2, rect.height / 2);
        this.reels.position.set(GAME_LAYOUT_WIDTH / 2, GAME_LAYOUT_HEIGHT / 2);
        this.reelFrame.eventMode = "static"; // prevents the character from receiving clicks when it's behind the reels (in portrait mode)


        this.game.addChild(this.reelFrame);


        // this.setupCharacter();




        this.backgroundSpine.state.setAnimation(0, "animation", true); // idle ANIMATION

        // this.character.state.setAnimation(0, "idle_1", true);
        this.reelFrame.alpha = 1;
        // this.characterCont.alpha = 1;
        this.backgroundImageCont.alpha = 1;
        this.backgroundSpine.alpha = 1;
        this.track.alpha = 1;



    }

    //@ts-ignore
    private calculateReeframePivot() {
        const visibleBounds = getVisibleLocalBounds(this.reels);
        const centerX = (visibleBounds.minX + visibleBounds.maxX) / 2;
        const centerY = (visibleBounds.minY + visibleBounds.maxY) / 2;

        this.reels.pivot.set(centerX, centerY);
        // this.reelFrame.position.set(Manager.screenwidth, Manager.screenHeight);
    }

    private updateTotalMult(multVal: number) {

        if (multVal == 0) { // meaning reset
            this.multiplierVal = 0;
            this.multiplierText.text = "";
        }
        else {
            this.multiplierVal += multVal;
            this.multiplierText.text = `${this.multiplierVal}x`;
            // sound.play('multiplier_hit_on_cheese', { volume: 1 });
            // this.multiplierMeter.state.setAnimation(0, "collect", false);
        }

    }

    // public collectMouseMult(multVal: number, multText: BitmapText): Promise<void> {
    //     return new Promise(async (resolve) => {

    //         const travelTime = isSuperQuickBtnOnGlobal ? 250 : 500;

    //         const text = new BitmapText({ text: `${multText.text}`, style: multText.style });
    //         text.anchor = 0.5;
    //         text.scale = this.sceneScale;
    //         this.addChild(text);

    //         // symbol.multText.text = "";

    //         const startPos = multText.getGlobalPosition();
    //         text.x = startPos.x;
    //         text.y = startPos.y;

    //         const targetPos = this.multiplierText.getGlobalPosition();

    //         const tween = new Tween(text, tweenGroup)
    //             .to({ x: targetPos.x, y: targetPos.y }, travelTime)
    //             .easing(Easing.Cubic.Out)
    //             .onComplete(async () => {

    //                 // this.cleanupMultTravelAnimation?.();
    //                 text.position.set(targetPos.x, targetPos.y);
    //                 tweenGroup.remove(tween);
    //                 this.removeChild(text);
    //                 text.destroy();

    //                 this.updateTotalMult(multVal);
    //                 // this.multiplierFX.state.setAnimation(0, "animation", false);

    //                 resolve();
    //             })
    //             .start();

    //     });
    // }


    public update(): void {
        tweenGroup?.update();

        this.reels?.update();
        // this.banner?.update();
        this.bigWin?.update();
    }

    public resize(screenWidth: number, screenHeight: number): void {

        // this.screenWidth = screenWidth;
        // this.screenHeight = screenHeight;

        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / GAME_LAYOUT_WIDTH, screenHeight / GAME_LAYOUT_HEIGHT);
        this.reels.position.set(GAME_LAYOUT_WIDTH / 2, GAME_LAYOUT_HEIGHT / 2);

        if (screenWidth > screenHeight) {
            scale = 1 * Math.min(screenWidth / 1920, screenHeight / 1080);
            // this.sceneScale = scale
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.game.scale.set(scale, scale);

            const xPos = (GAME_LAYOUT_WIDTH * scale - screenWidth) / 2;
            const yPos = ((GAME_LAYOUT_HEIGHT + 0) * scale - screenHeight) / 2;

            // this.y = -200 * scale;

            this.game.x = -xPos;
            this.game.y = -yPos;

            this.reels.scale = REEL_SCALE[(VISIBLE_SYMBOLS_PER_REEL[1] - 4)];
            (this.holdAndSpinReels) && (this.holdAndSpinReels.scale = REEL_SCALE[(VISIBLE_SYMBOLS_PER_REEL[1] - 4)]);


            // this.character.scale = 1;
            // this.characterCont.position.set(2150, 1920);


            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (GAME_LAYOUT_WIDTH * bgScale - screenWidth) / 2;
            const bgYPos = (GAME_LAYOUT_HEIGHT * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);

            this.backgroundSpine.position.set(screenWidth / 2, screenHeight / 2);
            this.backgroundSpine.scale.set(BG_SCALE_FACTOR);

            // this.holdAndWinTrigger.scale = 1;

            // hitArea = { x: -200, y: -500, w: 400, h: 750 };
            this.track.position.set(0, 825);
            this.track.scale = 1;

        }
        else {
            scale = 1.0 * Math.min(screenWidth / 1080, screenHeight / 1920);
            // this.sceneScale = scale
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.game.scale.set(scale, scale);

            const xPos = (GAME_LAYOUT_WIDTH * scale - screenWidth) / 2;
            const yPos = ((GAME_LAYOUT_HEIGHT + 0) * scale - screenHeight) / 2;

            // this.y = -300 * scale;

            this.game.x = -xPos;
            this.game.y = -yPos;

            this.reels.scale = 1;
            (this.holdAndSpinReels) && (this.holdAndSpinReels.scale = 1);

            // this.character.scale = 0.85;
            // this.characterCont.position.set(1800, 1050);

            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (GAME_LAYOUT_WIDTH * bgScale - screenWidth) / 2;
            const bgYPos = (GAME_LAYOUT_HEIGHT * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);

            this.backgroundSpine.position.set(screenWidth / 2, screenHeight / 2);
            this.backgroundSpine.scale.set(BG_SCALE_FACTOR);
            // this.holdAndWinTrigger.scale = 0.85;
            this.track.position.set(0, 825);
            this.track.scale = 1;
            // hitArea = { x: -225, y: -860, w: 455, h: 478 };
        }

        this.game.children.forEach(element => {
            if (element instanceof DisplayObject) {
                element.setPositionResize(Manager.Orientation);
            }
        });

        this.bigWin?.scale.set(scale, scale);
        this.bigWin?.position.set(screenWidth / 2, screenHeight / 2);
        this.bigWin?.resize(screenWidth, screenHeight);

        // this.banner?.resize(screenWidth, screenHeight);

    }

}
